import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={14}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_b_17061_17907)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.24425 0.470525C5.04613 0.248038 4.80581 0.000684228 4.50221 0.000684228H2.34649C1.05056 0.000684228 0 1.0167 0 2.27003L0 5.10003C0 5.14148 0.0358232 5.17438 0.0786871 5.17438C0.991097 5.17438 1.73075 5.88971 1.73075 6.77212C1.73075 7.65454 0.991097 8.36987 0.0786871 8.36987C0.0358232 8.36987 0 8.40277 0 8.44422L0 11.7307C0 12.984 1.05056 14 2.34649 14H4.95955C5.0019 14 5.03487 13.9648 5.03487 13.9238C5.03487 13.4616 5.4223 13.0869 5.90023 13.0869C6.37816 13.0869 6.7656 13.4616 6.7656 13.9238C6.7656 13.9648 6.79856 14 6.84092 14L14.8743 13.9993C16.1702 13.9993 17.2208 12.9833 17.2208 11.73V8.90879C17.2208 8.60579 16.9668 8.36608 16.6766 8.25178C16.0729 8.01397 15.6474 7.44078 15.6474 6.77147C15.6474 6.10215 16.0729 5.52896 16.6766 5.29115C16.9668 5.17685 17.2208 4.93714 17.2208 4.63414V2.26935C17.2208 1.01602 16.1702 0 14.8743 0L7.29827 0.000684228C6.99467 0.000684228 6.75435 0.248038 6.55623 0.470525C6.39754 0.648745 6.16251 0.761586 5.90024 0.761586C5.63797 0.761586 5.40294 0.648745 5.24425 0.470525Z"
        fill="#FB6B4A"
      />
    </g>
    <path
      d="M8.464 3.00307V2.10107H9.014V3.00307C9.652 3.04707 10.18 3.23407 10.576 3.56407C11.016 3.93807 11.291 4.51007 11.401 5.28007H10.521C10.444 4.75207 10.246 4.36707 9.938 4.11407C9.696 3.91607 9.388 3.80607 9.014 3.76207V6.64407C9.674 6.88607 10.125 7.05107 10.367 7.15007C11.137 7.55707 11.533 8.14007 11.533 8.91007C11.533 9.68007 11.258 10.2631 10.719 10.6481C10.279 10.9451 9.718 11.1101 9.014 11.1431V12.1111H8.464V11.1431C7.727 11.0991 7.166 10.8681 6.77 10.4611C6.33 10.0211 6.077 9.37207 6 8.49207H6.891C6.957 9.15207 7.133 9.62507 7.419 9.92207C7.661 10.1751 8.013 10.3291 8.464 10.3731V7.32607C8.068 7.17207 7.683 7.02907 7.298 6.89707C6.506 6.50107 6.121 5.91807 6.121 5.14807C6.121 4.43307 6.374 3.88307 6.902 3.50907C7.309 3.20107 7.826 3.02507 8.464 3.00307ZM9.014 7.52407V10.3731C9.476 10.3401 9.861 10.2191 10.147 9.99907C10.466 9.74607 10.631 9.39407 10.631 8.93207C10.631 8.39307 10.235 7.97507 9.465 7.67807C9.311 7.62307 9.157 7.56807 9.014 7.52407ZM8.464 6.44607V3.76207C8.068 3.78407 7.749 3.89407 7.518 4.07007C7.188 4.30107 7.023 4.66407 7.023 5.14807C7.023 5.64307 7.408 6.03907 8.189 6.34707L8.464 6.44607Z"
      fill="#3E3132"
      stroke="#3E3132"
      strokeWidth={0.5}
    />
    <defs>
      <filter
        id="filter0_b_17061_17907"
        x={-2.82244}
        y={-2.82244}
        width={22.8656}
        height={19.6449}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={1.41122} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_17061_17907"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_17061_17907"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SVGComponent;
